<script setup>


const toggleTheme = () => {
  const isDark = localStorage.theme === 'dark'
  if (isDark) {
    localStorage.theme = 'light';
    document.documentElement.classList.remove('dark');
  } else {
    localStorage.theme = 'dark';
    document.documentElement.classList.add('dark');
  }
}


const {search, closeSearchBox, searchResult, searchValue, searchBoxStatus} = useHeader()



</script>

<template>
  <header class="flex items-center justify-between shrink-0 w-full h-22 px-5 sm:px-7 bg-white max-lg:border-b max-lg:border-b-light lg:rounded-lg lg:dark:darker-gradient">
    <button class="btn-icon-area md:!hidden" @click="$emit('open-nav')">
      <Icon name="linear:category-2" class="size-6 text-primary"/>
    </button>
    <div class="relative z-60 hidden md:flex items-center justify-between gap-x-4 w-72 xl:w-85 bg-black-5 rounded-lg py-1 px-4 h-12">
      <input type="text" @input="search" :value="searchValue" placeholder="دوره های من، تیکت ها، مالی ..." class="size-full text-label placeholder:text-muted">
      <Icon name="linear:search-normal" class="text-muted shrink-0" />
      <div v-if="searchBoxStatus" class="absolute z-60 right-0 left-0 top-14  text-label p-4 bg-white rounded-md">
        <div class="text-center" v-if="searchResult.length <= 0">نتیجه ای یافت نشد</div>
        <div class="flex flex-col gap-y-2" v-else>
          <template v-for="(data, index) in searchResult" :key="index">
            <NuxtLink :to="data.url" v-if="data.url"  @click="closeSearchBox" class="flex items-center justify-between cursor-pointer select-none">
              <span>{{ data.title }}</span>
              <Icon name="linear:arrow-left" class="size-3.5 text-muted"/>
            </NuxtLink>
            <button v-else @click="closeSearchBox(); $emit('open-profile-modal')" class="flex items-center justify-between cursor-pointer select-none">
              <span>{{ data.title }}</span>
              <Icon name="linear:arrow-left" class="size-3.5 text-muted"/>
            </button>
          </template>
        </div>
      </div>
    </div>
    <div class="max-md:hidden fixed inset-0 bg-black/20 z-50" @click="closeSearchBox" v-if="searchBoxStatus"></div>

    <div class="flex items-center gap-x-5">
      <div class="flex gap-x-3">
        <button @click="toggleTheme" class="btn-icon-area text-primary">
          <Icon name="linear:moon" class="size-6 dark:hidden"/>
          <Icon name="linear:sun" class="size-6 hidden dark:inline-block"/>
        </button>
        <a href="https://sabzlearn.ir/cart/" target="_blank" class="btn-icon-area text-primary">
          <Icon name="linear:shopping-cart" class="size-6"/>
        </a>
        <button class="btn-icon-area text-primary">
          <Icon name="linear:notification-bing" class="size-6"/>
        </button>
      </div>
      <div class="max-lg:hidden w-px h-6 bg-light"></div>
      <NuxtTime class="max-lg:hidden text-label text-secondary select-none"
          :datetime="Date.now()"
          locale="fa"
          weekday="long"
          day="numeric"
          month="long"
      />
    </div>
  </header>
</template>

<style scoped>

</style>